export default "__VITE_ASSET___9iUoCuN__"